import { jsx as _jsx } from "react/jsx-runtime";
import { brandConfiguration } from "@/brands/config";
import { Box } from "@gemini/core";
import { Link } from "@gemini/ui";
export const RentalLinkCustomFallback = () => {
    var _a, _b;
    const { rentalLink } = (_b = (_a = brandConfiguration === null || brandConfiguration === void 0 ? void 0 : brandConfiguration.ads) === null || _a === void 0 ? void 0 : _a.fallbacks) !== null && _b !== void 0 ? _b : {
        fallbacks: { rentalLink: "" },
    };
    const fallbackLinkClick = () => {
        window.open(rentalLink.url, "_blank");
    };
    return (_jsx(Box, { position: "relative", minHeight: "sizing.24", children: _jsx(Box, { position: "absolute", zIndex: "zIndex.1", backgroundColor: "color.background.default", minHeight: "sizing.24", minWidth: "100%", children: _jsx(Link, { href: `#${rentalLink.label}`, onPress: fallbackLinkClick, variant: "standalone", children: rentalLink.label }) }) }));
};
